<div class="sidebar-brand d-flex align-items-center gap-2 mb-0 px-1 pt-1 min-w-0">

  <!-- Short Logo -->
  <div class="sidebar-brand-logo flex-shrink-0 mb-2 rounded-3" role="img" aria-label="Empire Partner Foundation"></div>


  <!-- Brand Title + Subtitle -->
  <div class="sidebar-brand-text d-flex flex-column mt-2">
    <p class="text-white text-uppercase fw-light text-xs fw-bold mb-1">{{ title }}</p>
    <p class="text-white-50 text-uppercase fw-light text-xs">{{ subtitle }}</p>
  </div>

</div>